var map = {
	"./artisVR_detail0.jpg": 165,
	"./artisVR_detail1.png": 6345,
	"./artisVR_thumbnail.jpg": 206,
	"./excavation_detail0.jpg": 4037,
	"./excavation_detail1.png": 9617,
	"./excavation_thumbnail.jpg": 899,
	"./gallery_detail0.jpg": 9496,
	"./gallery_detail1.png": 5545,
	"./gallery_thumbnail.jpg": 9734,
	"./hercules_detail0.jpg": 4676,
	"./hercules_detail1.png": 2249,
	"./hercules_thumbnail.jpg": 2820,
	"./mockapp_detail0.jpg": 5753,
	"./mockapp_detail1.png": 6975,
	"./mockapp_thumbnail.jpg": 3668,
	"./soundreactive_detail0.jpg": 9919,
	"./soundreactive_detail1.png": 8588,
	"./soundreactive_thumbnail.jpg": 9014,
	"./spook_detail0.jpg": 4902,
	"./spook_detail1.png": 140,
	"./spook_thumbnail.jpg": 7329,
	"./voronoi_detail0.jpg": 9577,
	"./voronoi_detail1.jpg": 9988,
	"./voronoi_thumbnail.jpg": 3069,
	"./website_detail0.jpg": 1871,
	"./website_detail1.png": 8762,
	"./website_thumbnail.jpg": 9257,
	"./witch_detail0.png": 6177,
	"./witch_detail1.png": 540,
	"./witch_thumbnail.jpg": 3850
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9293;